// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"2da790ee","144":"c252d132","623":"eb8e3e00","702":"83166c89","789":"b4637248","812":"a7ab1094"}[chunkId] + ".chunk.css";
};